<template>
  <v-card class="pa-0 ma-0">
    <v-card-text class="pt-2 pa-1">
      <v-form>
        <v-layout row wrap>
          <v-flex xs12 pa-1>
            <v-text-field
              label="Codice"
              box
              hide-details
              :value="$functions.getCodArticoloFormat(datiArticolo.cdArticolo)"
              :append-icon="'search'"
              v-on:input="cdArticolo = $event"
              @click:append="caricaDati()"
              ref="txtArt"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs4 pa-1>
            <v-text-field
              label="Ubicazione"
              v-model="datiArticolo.ubicazione"
              box
              hide-details
              ref="txtUbicaz"
              readonly
            ></v-text-field>
          </v-flex>-->

          <v-flex xs12 pa-1>
            <v-textarea
              label="Descrizione"
              v-model="datiArticolo.descrizione"
              box
              readonly
              hide-details
              rows="2"
            ></v-textarea>
          </v-flex>

          <v-flex xs9 pa-1>
            <v-text-field
              label="Codice art .fornitore"
              v-model="datiArticolo.cdArticoloFornitore"
              box
              readonly
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-text-field
              label="UM"
              v-model="datiArticolo.unMisura"
              box
              readonly
              hide-details
            ></v-text-field>
          </v-flex>

          <!-- Fornitori -->
          <v-flex xs12 pa-1>
            <v-select
              label="Fornitore"
              :items="getFornitori"
              v-model="fornitore"
              solo
              hide-details
            ></v-select>
          </v-flex>

          <v-flex xs4 pa-1>
            <v-text-field
              label="Cli"
              v-model.number="datiArticolo.qtaOrdinatoClienti"
              box
              hide-details
              type="number"
              class="font-weight-bold"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs4 pa-1>
            <v-text-field
              label="Scaf"
              v-model.number="datiArticolo.qtaScaffale"
              box
              hide-details
              type="number"
              class="font-weight-bold"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs4 pa-1>
            <v-text-field
              label="Ric"
              v-model.number="datiArticolo.qtaRicevuta"
              box
              hide-details
              type="number"
              class="font-weight-bold"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs4 pa-1>
            <v-text-field
              label="Qta for 1"
              v-model.number="datiArticolo.qtaOrdinatoForPer1"
              box
              hide-details
              type="number"
              class="font-weight-bold"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs4 pa-1>
            <v-text-field
              label="Qta for 2"
              v-model.number="datiArticolo.qtaOrdinatoForPer2"
              box
              hide-details
              type="number"
              class="font-weight-bold"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs4 pa-1>
            <v-text-field
              label="Qta for 3"
              v-model.number="datiArticolo.qtaOrdinatoForPer3"
              box
              hide-details
              type="number"
              class="font-weight-bold"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs6 pa-1>
            <v-text-field
              label="Media mensile"
              v-model.number="datiArticolo.scortaMedia"
              box
              hide-details
              type="number"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6 pa-1>
            <v-text-field
              label="Lotto riordino"
              v-model.number="datiArticolo.lottoDiRiordino"
              box
              hide-details
              type="number"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs6 pa-1>
            <v-text-field
              label="Qtà pre ordine"
              v-model.number="datiArticolo.qtPreOrdine"
              hide-details
              type="number"
              ref="txtQta"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4 pa-1>
            <!-- <v-select label="Mese" solo hide-details></v-select> -->

            <v-btn
              block
              dark
              large
              @click="inserisciPreOrdine()"
              :loading="attesaConferma"
              :disabled="attesaConferma"
              color="primary"
              >Conferma</v-btn
            >
          </v-flex>
        </v-layout>

        <!-- Bottone conferma -->
        <!-- <v-layout>
          <v-flex xs4 pa-1></v-flex>
          <v-flex xs4 pa-1>
            <v-btn
              block
              dark
              large
              @click="inserisciPreOrdine()"
              :loading="attesaConferma"
              :disabled="attesaConferma"
              color="primary"
            >Conferma</v-btn>
          </v-flex>
        </v-layout>
        -->
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { get_datiArticoliOrdiniFor, preOrdine } from "@/api/api.js";

export default {
  data: () => ({
    datiArticolo: {},
    cdArticolo: "",

    fornitore: "",

    attesa: false,
    attesaConferma: false,
  }),

  methods: {
    async caricaDati() {
      // Reset
      this.datiArticolo = {};

      if (!this.cdArticolo) return;

      // Elimino spazi di formattazione codice
      this.cdArticolo = this.$functions.trimAll(this.cdArticolo);

      this.attesa = true;

      try {
        let res = await get_datiArticoliOrdiniFor(this.cdArticolo);

        this.datiArticolo = res.data;
      } catch (error) {
        this.$toast.info(this.$functions.getErrorMsg(error));
      }

      this.setFornitorePredefinito();

      this.attesa = false;
    },

    setFornitorePredefinito() {
      this.fornitore = "";

      if (!this.datiArticolo.elencoFornitori) return;

      // NOTA: nel caso di singolo fornitore propongo quello, nel caso di multi fornitore deve scegliere
      let res = "";
      let arr = this.datiArticolo.elencoFornitori.split("|");
      if (arr.length == 1) res = arr[0];

      // Ricavo il fornitore predefinito da visualizzare nella combo
      // let forPred =
      //   this.datiArticolo.ultFornitore || this.datiArticolo.cdFornPrimario;

      // let arr = this.datiArticolo.elencoFornitori.split("|");
      // let res = "";
      // arr.forEach(element => {
      //   if (element.startsWith(forPred)) res = element;
      // });

      this.fornitore = res;
    },

    inserisciPreOrdine() {
      if (!this.validateInput()) return;

      let par = {
        cdArticolo: this.datiArticolo.cdArticolo,
        cdFornitore: this.fornitore.split(" ")[0],
        data: this.$functions.getDateIso(),
        qtPreOrdine: this.datiArticolo.qtPreOrdine,
        utente: this.$store.getters["user/getUser"],
      };

      preOrdine(par)
        .then((res) => {
          // Reset
          this.datiArticolo = {};
        })
        .catch((err) => {
          this.$toast.info(this.$functions.getErrorMsg(err));
        })
        .finally(() => (this.attesa = false));
    },

    validateInput() {
      if (Object.keys(this.datiArticolo).length == 0) {
        this.$toast.warning("Nessun dato presente");
        return false;
      }

      if (!this.fornitore) {
        this.$toast.warning("Fornitore non valido");
        return false;
      }

      if (this.datiArticolo.qtPreOrdine.length == 0) {
        this.$toast.warning("Quantità non valida");
        return false;
      }

      let qta = parseFloat(this.datiArticolo.qtPreOrdine);

      if (qta == 0) {
        this.$toast.warning("Quantità non valida");
        return false;
      }

      return true;
    },
  },

  computed: {
    getFornitori() {
      if (!this.datiArticolo.elencoFornitori) return [];
      return this.datiArticolo.elencoFornitori.split("|");
    },

    getCodebar() {
      return this.$store.getters["app/getCodebar"];
    },
  },

  watch: {
    getCodebar(v) {
      this.$refs.txtArt.focus();
      this.cdArticolo = v.barcodeData;

      this.caricaDati();
    },
  },
};
</script>